import React from 'react';
import { Route } from 'react-router';
import App from './containers/App';
import loginRequired from '../core/containers/loginRequired';
import ScoutReportFilter from '../features/scout-report/components/Filter';
import ScoutReport from '../features/scout-report/containers/ScoutReport';
import PasswordReset from '../features/auth/components/PasswordReset';
import Reset from '../features/auth/components/Reset';

export default <Route path="/" component={App}>
  <Route path="/team-scout-report" component={loginRequired(ScoutReportFilter)} />
  <Route path="/:seasonId/:seasonSlug/:leagueId/:leagueSlug/:teamId/:teamSlug">
    <Route path="/:seasonId/:seasonSlug/:leagueId/:leagueSlug/:teamId/:teamSlug/scout-report"
         component={loginRequired(ScoutReport)} editMode={ true } />
     <Route path="/:seasonId/:seasonSlug/:leagueId/:leagueSlug/:teamId/:teamSlug/scout-report/view"
          component={loginRequired(ScoutReport)} editMode={ false } />
  </Route>
  <Route path="/password-reset" component={PasswordReset} />
  <Route path="/password-reset/:uid/:token" component={Reset} />
</Route>;



// WEBPACK FOOTER //
// ./src/app/routes.js